<template>
  <van-popup
    class="address-popup"
    :value="show"
    @close="updateValue"
    @click-overlay="updateValue"
    position="bottom"
  >
    <AddressForm
      v-if="showEdit !== 'select'"
      @refresh="getUserAddressList"
      @toSelect="toSelect"
      :editAddressInfo="editAddressInfo"
      :type="showEdit"
    />
    <SelectAddress
      v-else
      @editAddress="editAddress"
      :addressList="addressList"
      :address="selectAddress"
      @selectAddress="handleSelectAddress"
      @closePopup="updateValue"
    />
  </van-popup>
</template>

<script>
import { defineComponent, ref, onMounted } from "@vue/composition-api";

import AddressForm from "./AddressForm.vue";
import SelectAddress from "./SelectAddress.vue";

export default defineComponent({
  props: ["show", "addressList", "selectAddress", "getUserAddressList"],
  components: {
    AddressForm,
    SelectAddress,
  },
  setup(props, { emit }) {
    const showEdit = ref("select");
    const editAddressInfo = ref({});

    onMounted(() => {});

    const updateValue = () => {
      emit("update:show", false);
    };

    const editAddress = (value, address) => {
      showEdit.value = value;
      editAddressInfo.value = address;
    };

    const handleSelectAddress = (addressObj) => {
      emit("handleSelectAddress", addressObj);
    };

    const toSelect = () => {
      showEdit.value = "select";
      editAddressInfo.value = {};
    };

    return {
      showEdit,
      editAddressInfo,
      editAddress,
      updateValue,
      handleSelectAddress,
      toSelect,
    };
  },
});
</script>

<style lang="less" scoped>
.address-popup {
  width: 100%;
  background: #f8f8f8;
  border-radius: 24px 24px 0px 0px;
  box-sizing: border-box;
  padding: 0 12px;
  padding-top: 27px;
}
</style>
